import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const clear = dom.find('[data-clear]');
    const showall = dom.find('[data-showall]');
    const showallOpen = showall.find('span').text();
    const showallClose = showall.data('showall');
    const filters = dom.find('[data-filter]');
    const checkboxes = dom.find('input');

    const update = () => {
        const url = document.location.pathname.replace(/\/side\d+/, '');
        const params = filters.map(filter => {
            const key = $(filter).data('filter');
            return {
                key,
                value: $(filter).find('input:checked').map(input => input.value).join('|')
            };
        })
            .map(filter => (filter.value.length ? `${filter.key}=${filter.value}` : false))
            .filter(value => value)
            .join('&');

        window.location.href = params.length ? `${url}?${params}` : url;
    };

    const toggleAll = e => {
        const btn = $(e.triggerTarget);
        const target = $(`#${btn.attr('aria-controls')}`);
        const open = btn.attr('aria-expanded') === 'true';
        btn.attr('aria-expanded', !open);
        btn.find('span').text(open ? showallOpen : showallClose);
        target.toggleClass('-open', !open);
    };

    const toggleClear = () => {
        filters.each(node => {
            const filter = $(node);
            if (filter.find('input:checked').length) {
                filter.find('[data-clear]').attr('hidden', null);
            }
        });
    };

    const reset = e => {
        const btn = $(e.triggerTarget);
        btn.parent().find('[type="checkbox"]').attr('checked', null);
        btn.attr('hidden', '');
        update();
    };

    const init = () => {
        clear.on('click', reset);
        checkboxes.on('change', update);
        showall.on('click', toggleAll);
        toggleClear();
    };

    const destroy = () => {
        clear.off('click', reset);
        checkboxes.off('change', update);
        showall.off('click', toggleAll);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FilterMenu.js